import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionJuradaViolenciaGeneroByID from "services/record/DeclaracionJuradaViolenciaGenero/useGetDeclaracionJuradaViolenciaGeneroByID";
import useGetInfoDeclaracionJuradaViolenciaGenero from "services/record/DeclaracionJuradaViolenciaGenero/useGetInfoDeclaracionJuradaViolenciaGenero";
import useGetDeclaracionJuradaViolenciaGeneroByUser from "services/record/DeclaracionJuradaViolenciaGenero/useGetDeclaracionJuradaViolenciaGeneroByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionJuradaViolenciaGenero from "./DeclaracionJuradaViolenciaGenero";

const GridDeclaracionJuradaViolenciaGenero = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionJuradaViolenciaGeneroByID,
        loadingGetDeclaracionJuradaViolenciaGeneroByID,
        statusGetDeclaracionJuradaViolenciaGeneroByID
    } = useGetDeclaracionJuradaViolenciaGeneroByID();

    const {
        getInfoDeclaracionJuradaViolenciaGenero,
        loadingGetInfoDeclaracionJuradaViolenciaGenero,
        statusGetInfoDeclaracionJuradaViolenciaGenero
    } = useGetInfoDeclaracionJuradaViolenciaGenero();

    const {
        dataGetDeclaracionJuradaViolenciaGeneroByUser,
        getDeclaracionJuradaViolenciaGeneroByUser,
        loadingGetDeclaracionJuradaViolenciaGeneroByUser,
        statusGetDeclaracionJuradaViolenciaGeneroByUser
    } = useGetDeclaracionJuradaViolenciaGeneroByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración jurada fuerza mayor y violencia de género";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getDeclaracionJuradaViolenciaGeneroByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetDeclaracionJuradaViolenciaGeneroByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaViolenciaGeneroByID.status,
                statusText: statusGetDeclaracionJuradaViolenciaGeneroByID.statusText
            });
        } else if (statusGetInfoDeclaracionJuradaViolenciaGenero?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionJuradaViolenciaGenero.status,
                statusText: statusGetInfoDeclaracionJuradaViolenciaGenero.statusText
            });
        } else if (statusGetDeclaracionJuradaViolenciaGeneroByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaViolenciaGeneroByUser.status,
                statusText: statusGetDeclaracionJuradaViolenciaGeneroByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionJuradaViolenciaGeneroByID,
        statusGetInfoDeclaracionJuradaViolenciaGenero,
        statusGetDeclaracionJuradaViolenciaGeneroByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionJuradaViolenciaGeneroByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionJuradaViolenciaGenero(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetDeclaracionJuradaViolenciaGeneroByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionJuradaViolenciaGeneroByUser]);

    const isLoading = () => {
        return (
            loadingGetDeclaracionJuradaViolenciaGeneroByID ||
            loadingGetInfoDeclaracionJuradaViolenciaGenero ||
            (loadingGetDeclaracionJuradaViolenciaGeneroByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionJuradaViolenciaGeneroByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionJuradaViolenciaGenero
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionJuradaViolenciaGeneroByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionJuradaViolenciaGenero;

